import { useTheme } from "@mui/material";

export const Logo = () => {
  const theme = useTheme();
  return (
    <>
      <svg
        width="106"
        height="33"
        viewBox="0 0 106 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M58.7109 13.6863C57.3094 15.0544 55.9086 16.4232 54.5077 17.7914L55.281 20.1717H48.66L49.4556 17.7337L45.455 13.8266L39.5483 29.6741H45.7286L47.4237 24.5175H56.6055L58.318 29.6741H64.533L58.7116 13.6863H58.7109Z"
          fill={theme.palette.text.primary}
        />
        <path
          d="M20.3871 9.41787C19.9887 8.40635 19.3903 7.56431 18.5927 6.89177C17.7951 6.21923 16.7982 5.71482 15.6022 5.37855C14.4061 5.04228 13.0102 4.87415 11.4156 4.87415H2.48096V9.1494H8.6334C8.6334 9.1494 8.63826 9.15076 8.64034 9.15076H10.4264C11.9446 9.15076 13.0837 9.48431 13.8432 10.1508C14.6026 10.8179 14.9823 11.8233 14.9823 13.1691C14.9823 14.5148 14.6026 15.563 13.8432 16.247C13.0837 16.9311 11.9453 17.2728 10.4264 17.2728H8.18427V17.2647H2.48096V29.603H8.18427V21.4979H10.9033C12.434 21.4979 13.8105 21.3019 15.033 20.9094C16.2554 20.5169 17.3244 19.9284 18.24 19.144C19.155 18.3596 19.8415 17.4518 20.299 16.4213C20.7564 15.3908 20.9855 14.2375 20.9855 12.9616C20.9855 11.6104 20.7863 10.4294 20.3871 9.41787Z"
          fill={theme.palette.text.primary}
        />
        <path
          d="M101.054 4.87341V20.4626H103.438V24.5324H101.054V29.6022H95.7573V24.5324H85.3218V20.2734C86.2402 19.2043 87.196 18.0341 88.1908 16.7643C89.1855 15.4938 90.1421 14.186 91.0598 12.8409C91.99 11.4958 92.8522 10.1419 93.647 8.77985C94.4411 7.41782 95.1152 6.11545 95.6684 4.87409H101.054L101.054 4.87341ZM90.1775 20.4626H95.7573V11.9609C95.3685 12.708 94.9416 13.4646 94.4772 14.2287C94.0121 14.9934 93.5442 15.7432 93.0736 16.4795C92.5905 17.2036 92.1025 17.9019 91.6082 18.5744C91.114 19.247 90.637 19.8768 90.1782 20.4626H90.1775Z"
          fill="url(#paint0_linear_12_1242)"
        />
        <path
          d="M86.6581 29.6741H79.5422L72.1618 19.1371C72.0909 19.0341 72 18.8673 71.8882 18.6375C71.7765 18.4076 71.6439 18.1202 71.4912 17.7751H71.403V29.6741H65.6997V4.94458H71.403V16.4124H71.4912C71.562 16.251 71.6557 16.0558 71.7737 15.8259C71.891 15.5961 72.0326 15.3317 72.1972 15.0327L79.1895 4.94458H85.8112L77.1063 16.6022L86.6588 29.6741H86.6581Z"
          fill={theme.palette.text.primary}
        />
        <path
          d="M52.5319 5.24915C53.4802 7.69639 51.9479 17.1663 51.9479 17.1663C51.9479 17.1663 44.3711 11.0383 43.4222 8.59111C42.4739 6.14387 43.7438 3.41152 46.2599 2.48897C48.7753 1.56642 51.5837 2.80191 52.5319 5.24983V5.24915Z"
          fill={theme.palette.primary.light}
        />
        <path
          d="M60.6057 8.72554C59.617 11.1578 51.939 17.1663 51.939 17.1663C51.939 17.1663 50.5637 7.67401 51.5524 5.2417C52.5411 2.8094 55.3698 1.61803 57.8698 2.57995C60.3698 3.54188 61.5944 6.29391 60.6057 8.72622V8.72554Z"
          fill={theme.palette.secondary.main}
        />
        <path
          d="M37.8593 29.6022H22.6743V4.87341H37.2769V9.40833H28.3776V14.9093H36.6584V19.4273H28.3776V25.0836H37.8593V29.6016V29.6022Z"
          fill={theme.palette.text.primary}
        />
        <defs>
          <linearGradient
            id="paint0_linear_12_1242"
            x1="85.3218"
            y1="17.2382"
            x2="103.438"
            y2="17.2382"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={theme.palette.primary.light} />
            <stop offset="1" stopColor={theme.palette.secondary.main} />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};
